import React, { useState, useEffect } from "react";
import "./MathQuizz.css";

export default function MathQuizz() {
  const [question, setQuestion] = useState({});
  const [answer, setAnswer] = useState("");
  const [score, setScore] = useState(0);
  const [time, setTime] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [message, setMessage] = useState("");
  const [usedQuestions, setUsedQuestions] = useState([]);
  const [difficulty, setDifficulty] = useState("easy");

  // Load sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  useEffect(() => {
    generateQuestion();
    setScore(0);
    setTime(0);
    setGameOver(false);
    setMessage("");
    setUsedQuestions([]);
  }, [difficulty]);

  useEffect(() => {
    let timer;
    if (!gameOver) {
      timer = setInterval(() => setTime((t) => t + 1), 1000);
    }
    return () => clearInterval(timer);
  }, [gameOver]);

  const generateQuestion = () => {
    const operators = ["+", "-", "×"];
    let maxNum = difficulty === "easy" ? 10 : difficulty === "medium" ? 20 : 50;
    let num1 = Math.floor(Math.random() * maxNum) + 1;
    let num2 = Math.floor(Math.random() * maxNum) + 1;
    let operator = operators[Math.floor(Math.random() * operators.length)];

    let newQ = { num1, num2, operator };

    // Ensure uniqueness
    let key = `${num1}${operator}${num2}`;
    if (usedQuestions.includes(key)) {
      return generateQuestion();
    }
    setUsedQuestions([...usedQuestions, key]);
    setQuestion(newQ);
  };

  const checkAnswer = () => {
    let correct;
    if (question.operator === "+") correct = question.num1 + question.num2;
    if (question.operator === "-") correct = question.num1 - question.num2;
    if (question.operator === "×") correct = question.num1 * question.num2;

    if (parseInt(answer) === correct) {
      setScore(score + 10);
      setMessage("✅ Correct!");
      correctSound.play();
      if (score + 10 >= 100) {
        setMessage("🎉 You win! Final Score: " + (score + 10));
        setGameOver(true);
        winSound.play();
      } else {
        generateQuestion();
      }
    } else {
      setScore(score - 5);
      setMessage("❌ Wrong, try again!");
      wrongSound.play();
    }
    setAnswer("");
  };

  return (
    <div className="quiz-container">
      <h1>🧮 Math Quiz Game</h1>
      <div className="mode-buttons">
        <button onClick={() => setDifficulty("easy")}>Easy</button>
        <button onClick={() => setDifficulty("medium")}>Medium</button>
        <button onClick={() => setDifficulty("hard")}>Hard</button>
      </div>
      <div className="stats">
        <p>⏱ Time: {time}s</p>
        <p>⭐ Score: {score}</p>
      </div>
      {!gameOver ? (
        <div className="quiz-card">
          <p className="question">
            {question.num1} {question.operator} {question.num2} = ?
          </p>
          <input
            type="number"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            className="answer-input"
          />
          <button onClick={checkAnswer}>Submit</button>
        </div>
      ) : (
        <h2>{message}</h2>
      )}
      <p className="status">{message}</p>
    </div>
  );
}

